// Mega menu Hover change image code Start
document.addEventListener("DOMContentLoaded", function () {
  const promoImg = document.querySelector(".ct-mega-menu-promo-img img.ct-hover-change");
  const originalSrc = promoImg.src;
  const originalSrcset = promoImg.srcset;
  const menuItems = document.querySelectorAll(".ct-mega-menu-title");
  menuItems.forEach((item) => {
    item.addEventListener("mouseenter", function () {
      const img = item.querySelector("img");
      const imgSrc = img.src;
      const imgSrcset = img.srcset;
      promoImg.src = imgSrc;
      promoImg.srcset = imgSrcset;
    });
    item.addEventListener("mouseleave", function () {
      promoImg.src = originalSrc;
      promoImg.srcset = originalSrcset;
    });
  });
});
// Mega menu Hover change image code End

// Get all elements with the class "header__menu-disclosure"
const menuDisclosureItems = document.querySelectorAll(
  ".header__menu-disclosure"
);
menuDisclosureItems.forEach((item) => {
  item.addEventListener("mouseenter", function () {
    this.setAttribute("aria-expanded", "true");
    this.setAttribute("open", "");
    const megaMenu = this.querySelector(".ct-mega-menu-main");
    megaMenu.style.opacity = "1";
  });

  item.addEventListener("mouseleave", function () {
    this.removeAttribute("aria-expanded");
    this.removeAttribute("open");
    const megaMenu = this.querySelector(".ct-mega-menu-main");
    megaMenu.style.opacity = "0";
  });
});

// Get all containers with the class 'ct-dressfolk-sarees-inner'
const containers = document.querySelectorAll(".ct-dressfolk-sarees-inner");
containers.forEach((container) => {
  const tabTitles = container.querySelectorAll(
    ".ct-dressfolk-sarees-coll-heading"
  );
  const tabContents = container.querySelectorAll(
    ".ct-dressfolk-sarees-collection-main"
  );

  tabTitles.forEach((title, index) => {
    title.addEventListener("click", () => {
      // Remove 'is_active' class from all tab titles and contents within this container
      tabTitles.forEach((title) => title.classList.remove("is_active"));
      tabContents.forEach((content) => content.classList.remove("is_active"));

      // Add 'is_active' class to the clicked tab title and corresponding content within this container
      title.classList.add("is_active");
      tabContents[index].classList.add("is_active");
    });
  });
});

// Coupon code js start
// $(document).ready(function() {
//   // Select the elements
//   const $couponHeading = $('.ct-coupon-heading');
//   const $couponMain = $('.ct-coupon-main');

//   // Add click event listener to the coupon heading
//   $couponHeading.on('click', function() {
//     // Toggle the 'is_open' class on the coupon main element
//     $couponMain.toggleClass('is_open');
//   });
// });
// Coupon code js End
document.addEventListener("DOMContentLoaded", function() {
    var ct_dressfolk_collection = new Swiper(".ct_dressfolk_collection", {
      slidesPerView: "auto",
      spaceBetween: 5,
      pagination: {
        clickable: true,
      },
      navigation: {
        nextEl: ".ct-dressfolk-next",
        prevEl: ".ct-dressfolk-prev",
      },
    });

    var ct_Loved_customers = new Swiper(".ct_Loved_customers", {
      slidesPerView: "auto",
      spaceBetween: 10,
      pagination: {
        clickable: true,
      },
      navigation: {
        nextEl: ".ct-Loved-custo-next",
        prevEl: ".ct-Loved-custo-prev",
      },
    });
});
// variant change JS start
jQuery(document).ready(function ($) {
  setInterval(displayHello, 1000);

  function displayHello() {
    var uniqueKey = "timestamp_" + Date.now();
    jQuery(".unique_key").val(uniqueKey);
  }
  variantChangeFunction();
  function variantChangeFunction() {
    var selectedSizes = {
      ProductForm_Option_num1: null,
      ProductForm_Option_num2: null,
    };

    function normalizeSizeValue(value) {
      return (value || "").toString().replace(/\s+/g, "").trim();
    }

    function getAvailableVariantPairs() {
      var availablePairs = [];

      $(".ProductForm_Option_main select option").each(function () {
        if ($(this).is(":disabled")) {
          return;
        }

        var variantTitle = normalizeSizeValue($(this).data("sele_value"));

        if (!variantTitle) {
          return;
        }

        availablePairs.push(variantTitle.split("/"));
      });

      return availablePairs;
    }

    function toggleOptionAvailability($items, isEnabledCallback) {
      $items.each(function () {
        var $item = $(this);
        var $input = $item.find("input.ct_SizeSwatch_Radio");
        var enabled = isEnabledCallback(normalizeSizeValue($item.attr("data-show-value")));

        $input.prop("disabled", !enabled);
        $item.toggleClass("is-disabled", !enabled);

        if (!enabled && $input.is(":checked")) {
          $input.prop("checked", false);
        }
      });
    }

    function syncSwatchAvailability() {
      var availablePairs = getAvailableVariantPairs();
      var selectedOption1 = normalizeSizeValue($(".ProductForm_Option_num1 input.ct_SizeSwatch_Radio:checked").val());
      var selectedOption2 = normalizeSizeValue($(".ProductForm_Option_num2 input.ct_SizeSwatch_Radio:checked").val());
      var hasSecondOption = $(".ProductForm_Option_num2").length > 0;

      toggleOptionAvailability($(".ProductForm_Option_num1 .HorizontalList__Item"), function (value) {
        if (!value) {
          return false;
        }

        return availablePairs.some(function (pair) {
          return pair[0] === value;
        });
      });

      toggleOptionAvailability($(".ProductForm_Option_num2 .HorizontalList__Item"), function (value) {
        if (!value) {
          return false;
        }

        if (selectedOption1) {
          return availablePairs.some(function (pair) {
            return pair[0] === selectedOption1 && pair[1] === value;
          });
        }

        return availablePairs.some(function (pair) {
          return pair[1] === value;
        });
      });
    }

    function updateSelectedSizes() {
      syncSwatchAvailability();

      // Reset selected sizes
      selectedSizes = {
        ProductForm_Option_num1: null,
        ProductForm_Option_num2: null,
      };

      $("input.ct_SizeSwatch_Radio:checked").each(function () {
        var selectedSize = $(this).val();
        
        // var selectedQuantity = $(this).parents("li.HorizontalList__Item").attr("data-quantity");
        // // var selectedQuantity = $('.ProductForm_Option_main select option:selected').attr("data-quantity");
        //   // console.log(selectedQuantity, " selectedQuantity");
        // if(selectedQuantity < 1 ){
        //   $('.ct-quantity-erroe').show();
        //   $('.ct-buy-btn button').attr('disabled', true);          
        // }
        // else{
        //   $('.ct-quantity-erroe').hide();
        //   $('.ct-buy-btn button').removeAttr('disabled');          
        // }

        
        var parentClass = $(this).closest(".ProductForm__Option").attr("class");
        if (parentClass.includes("ProductForm_Option_num1")) {
          selectedSizes["ProductForm_Option_num1"] = selectedSize;
        } else if (parentClass.includes("ProductForm_Option_num2")) {
          selectedSizes["ProductForm_Option_num2"] = selectedSize;
        }
        setTimeout(function(){
             var selectedQuantity = $('.ProductForm_Option_main select option:selected').attr("data-quantity");
                  // console.log(selectedQuantity, " selectedQuantity22");
                if(selectedQuantity < 1 ){
                  $('.ct-quantity-erroe:first').show();
                  $('.ct-buy-btn button').attr('disabled', true);          
                }
                else{
                  $('.ct-quantity-erroe').hide();
                  $('.ct-buy-btn button').removeAttr('disabled');          
                }
        },1000)
      });
      if (
        selectedSizes["ProductForm_Option_num1"] &&
        selectedSizes["ProductForm_Option_num2"]
      ) {
        var combinedSize =
          selectedSizes["ProductForm_Option_num1"] +
          "/" +
          selectedSizes["ProductForm_Option_num2"];
        updateSelectOption(combinedSize);
        $(".ct-pro-info-buy_buttons").addClass("variant_selected");
      } else if (selectedSizes["ProductForm_Option_num1"]) {
        var singleSize = selectedSizes["ProductForm_Option_num1"];
        updateSelectOption(singleSize);
        $(".ct-pro-info-buy_buttons").addClass("variant_selected");
      } else {
        if (
          $(".ProductForm_Option_num1").length &&
          $(".ProductForm_Option_num2").length
        ) {
          $('.ct-pro-info-buy_buttons input[name="id"]').removeAttr("value");
        }
        $(".ct-pro-info-buy_buttons").removeClass("variant_selected");
      }
    }

    function updateSelectOption(combinedSize) {
      $("select option").each(function () {
        if ($(this).data("sele_value") === combinedSize) {
          $(this).prop("selected", true);
          var selectedValue = $(this).val();
          $('.ct-pro-info-buy_buttons input[name="id"]').val(selectedValue);
          return false; // Break the loop once a match is found
        }
      });
    }

    function showSizeSelectMsg() {
      if (!selectedSizes["ProductForm_Option_num1"]) {
        $(".ProductForm_Option_num1 #SizeSelectMsg").show();
      } else if (
        $(".ProductForm__Option.ProductForm_Option_num2").length &&
        !selectedSizes["ProductForm_Option_num2"]
      ) {
        $(".ProductForm_Option_num2 #SizeSelectMsg").show();
        $(".ProductForm_Option_num1 #SizeSelectMsg").hide();
      } else {
        $(".ProductForm_Option_num2 #SizeSelectMsg").hide();
        $(".ProductForm_Option_num1 #SizeSelectMsg").hide();
      }
    }

    updateSelectedSizes();
    syncSwatchAvailability();

    $("input.ct_SizeSwatch_Radio").on("change", function () {
      updateSelectedSizes();
      showSizeSelectMsg();
      syncSwatchAvailability();
    });

    // Initial check on page load
    setTimeout(() => {
      $(".ct_SizeSwatch_Radio").removeAttr("checked");
      if (
        $(".ProductForm_Option_num1").length &&
        $(".ProductForm_Option_num2").length
      ) {
        $('.ct-pro-info-buy_buttons input[name="id"]').removeAttr("value");
      } else if ($(".ProductForm_Option_num1").length) {
        $('.ct-pro-info-buy_buttons input[name="id"]').removeAttr("value");
      }

      $(".ct-pro-info-buy_buttons").removeClass("variant_selected");
      syncSwatchAvailability();
    }, 1000);

    $(".ct-buy-btn").on("click", function () {
      var sizeSwatchRadio = $("input.ct_SizeSwatch_Radio");
      if (
        sizeSwatchRadio.length > 0 &&
        sizeSwatchRadio.filter(":checked").length === 0
      ) {
        $('.ct-pro-info-buy_buttons input[name="id"]').removeAttr("value");
        $(".ct-pro-info-buy_buttons").removeClass("variant_selected");
        showSizeSelectMsg();
      }
    });

    // $(".ct-pamb-size-main.is_size_open .ct-buy-btn").on("click", function () {
    //   var sizeSwatchRadio = $(".size_option_wrapper .variant-select.selected");
    //   if ( !sizeSwatchRadio) {
    //       $(".ct-pamb-size-main.is_size_open .SizeSelectMsg").show();
    //   }
    // });

    $(document).on("click", ".icon-quickview", function () {
      setTimeout(() => {
        var parentBlock = $(
          ".product-info__block-item.ct-pro-info-buy_buttons"
        );
        var inputValue = parentBlock.find('input[name="id"]').val();

        $(".ProductForm__LabelLink").on("click", function () {
          const shadowRootWrapper = document.querySelector("quick-buy-modal");
          const shadowRoot = shadowRootWrapper.shadowRoot;
          const innerElement = shadowRoot.querySelector(
            ".ct-quick-view-main-two"
          );
          const parentEle = $(".ct-quick-buy-Vmodal-main").addClass(
            "is_size_open"
          );
        });

        setTimeout(function () {
          var sizeSwatchRadio = $("input.ct_SizeSwatch_Radio");
          if (
            sizeSwatchRadio.length > 0 &&
            sizeSwatchRadio.filter(":checked").length === 0
          ) {
            $('.ct-pro-info-buy_buttons input[name="id"]').removeAttr("value");
            $(".ct-pro-info-buy_buttons").removeClass("variant_selected");
            // showSizeSelectMsg();
          }
          // $('.ct-pro-info-buy_buttons input[name="id"]').removeAttr("value");
        }, 1000);
        variantChangeFunction();
        openSizeChart();
      }, 2000);
    });
  }
});
// variant change JS End

// Size chart open code Start
openSizeChart();
function openSizeChart() {
  // Get the button and the modal elements
  var openModalButton = document.querySelector(".ProductForm__LabelLink");
  var modal = document.querySelector(".Product__OffScreen");
  var closeButton = document.querySelector(".close-button");

  openModalButton &&
    modal &&
    openModalButton.addEventListener("click", function (e) {
      modal.style.display = "block";
      modal.classList.add("open");
    });

  // Add click event listener to the close button
  closeButton &&
    closeButton.addEventListener("click", function () {
      closeDrawer();
    });

  // Add event listener to close the modal when clicking outside of it
  window.addEventListener("click", function (event) {
    if (event.target === modal) {
      closeDrawer();
    }
  });

  function closeDrawer() {
    modal.classList.remove("open");
    setTimeout(function () {
      $(".ct-quick-buy-Vmodal-main").removeClass("is_size_open");
    }, 500);

    const modalContent = $(".quick-buy-modal::part(content)");
    if (modalContent.length) {
      modalContent.css("overflow", "auto");
    }
    setTimeout(function () {
      modal.style.display = "none";
    }, 500);
  }
}
// Size chart open code End


// product Offer swiper code start
// function offer_slider() {
//   var slideCount = document.querySelectorAll(
//     ".offer_sale .swiper-slide"
//   ).length;

//   if (slideCount > 1) {
//     var loopEnabled = slideCount >= 3; 
//     var centeredSlidesEnabled = slideCount >= 3; 
//     var offer_sale = new Swiper(".offer_sale", {
//       slidesPerView: 1.3,
//       centeredSlides: centeredSlidesEnabled,
//       spaceBetween: 15,
//       loop: loopEnabled,
//       pagination: {
//         el: ".swiper-pagination",
//         clickable: true,
//       },
//     });
    
//     if (slideCount >= 3) {
//       offer_sale.slideTo(2, 0); 
//     }
//   }
// }
// $(document).ready(function () {
//   offer_slider();
// });

// product Offer swiper code end


// PDP Menu open code js start
$(document).ready(function () {
  const $menuHeading = $(".ct-header-nav-pdp-btn");
  const $menuMain = $(".ct-header-nav-pdp");
  const $menuclose = $(".ct-header-nav-pdp .ct-pdp-menu-close");
  $menuHeading.on("click", function () {
    $menuMain.addClass("is_open");
  });
  $menuclose.on("click", function () {
    $menuMain.removeClass("is_open");
  });
});

$(document).on("click", ".ct_menu_Suit, .ct_menu_Blouse, .ct_menu_Saree", function () {
    const clickedClass = [...$(this).attr("class").split(" ")].find(cls => cls.startsWith("ct_menu_"));
    // console.log(clickedClass);
    const targetClass = clickedClass.replace("ct_menu_", "ct_mmenu_");
    // console.log(targetClass);
    $('.ct-product-page .ct-header-nav-mob-main').show();
    $(`.${targetClass}`).trigger('click');
});
// PDP Menu open code js End

// PDP Pre order code js Start
// $(document).ready(function () {
//     $(window).on('scroll', function () {
//         const $notifySticky = $('.ct_notify_sticky');
//         const $stickyBar = $('.ct-product-sticky-bar');
//         const $footer = $('footer');
//         const scrollTop = $(this).scrollTop(); 
//         const windowHeight = $(window).height();
//         const footerTop = $footer.offset().top;
//         if ($notifySticky.length && $stickyBar.length) {
//             const notifyStickyBottom = $notifySticky.offset().top + $notifySticky.outerHeight();
//             const isFooterVisible = scrollTop + windowHeight > footerTop;
//             if (notifyStickyBottom < scrollTop && !isFooterVisible) {
//                 $stickyBar.addClass('is-visible');
//             } else {
//                 $stickyBar.removeClass('is-visible');
//             }
//         }
//     });
// });
// document.addEventListener("DOMContentLoaded", function() {
//     const $stickyBar = $('.ct-product-sticky-bar');
//     const $footer = $('footer');

//     $(window).on('scroll', function () {
//         const scrollTop = $(window).scrollTop();
//         const windowHeight = $(window).height();
//         const footerTop = $footer.offset().top;

//         const isFooterVisible = scrollTop + windowHeight > footerTop;

//         if (scrollTop > 0 && !isFooterVisible) {
//             $stickyBar.addClass('is-visible');
//         } else {
//             //$stickyBar.removeClass('is-visible');
//         }
//     });
// });
// PDP Pre order code js End

$(".ct-continue-pre-order-btn").on("click", function () {
    $(".ct-pro-info-buy_buttons .buy-buttons.buy-buttons.ct-buy-btn button").trigger("click");
});
$(".ct-product-sticky-bar .ct-continue-pre-order-btn").on("click", function () {
    $(".ct-product-sticky-bar .ct_pre-order-continue button").trigger("click");
});










// menu js for tabing add by devraj jangid
$(document).ready(function () {
  $('.ct-menu-iner').each(function () {
    var $menuContainer = $(this); 

    $menuContainer.find('.buton_menu').on('click', function () {
      
      var classes = $(this).attr('class').split(/\s+/);
      var targetIndex = null;

      
      $.each(classes, function (i, className) {
        if (className.startsWith('buton_menu_target_')) {
          targetIndex = className.replace('buton_menu_target_', '');
        }
      });

      if (targetIndex) {
        
        $menuContainer.find('.buton_menu').removeClass('active');
        $menuContainer.find('.buton_menu_last').removeClass('active');

        
        $(this).addClass('active');

        
        $menuContainer.find('.buton_target_menu' + targetIndex).addClass('active');
      }
    });
  });



  $('.ct-menu-btn').on('click', function () {
    $(this).closest('.ct-menu-iner').toggleClass('active');
  });
});

